import styled from "styled-components";

export const ButtonContainer = styled.div<{ $justifyFlexEnd: boolean }>`
    display: flex;
    justify-content: ${props => props.$justifyFlexEnd
    ? "flex-end"
    : "space-between"};
    width: 100%;
    margin-top: auto;
`;
